import { useMemo } from 'react';
import { Flex, Icon, SimpleGrid } from '@chakra-ui/react';
import { MdError, MdShield, MdVisibility, MdWarning } from 'react-icons/md';
import IconBox from '../../../components/icons/IconBox';
import MiniStatistics from '../../../components/card/MiniStatistics';
import { ChurnDistributionDto } from '../../../models/churn-prediction/dto/churn-prediction.dto';
import { translate } from '../../../i18n';

interface Props {
  distribution: ChurnDistributionDto;
}

export default function ChurnTierDistributionCards({ distribution }: Props) {
  const cards = useMemo(() => [
    {
      name: translate('churn_prediction.tier_safe'),
      value: distribution.safe,
      icon: MdShield,
      iconBg: 'green.100',
      iconColor: 'green.500',
    },
    {
      name: translate('churn_prediction.tier_watch'),
      value: distribution.watch,
      icon: MdVisibility,
      iconBg: 'yellow.100',
      iconColor: 'yellow.500',
    },
    {
      name: translate('churn_prediction.tier_at_risk'),
      value: distribution.atRisk,
      icon: MdWarning,
      iconBg: 'orange.100',
      iconColor: 'orange.500',
    },
    {
      name: translate('churn_prediction.tier_critical'),
      value: distribution.critical,
      icon: MdError,
      iconBg: 'red.100',
      iconColor: 'red.500',
    },
  ], [distribution]);

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap="20px" mb="20px">
      {cards.map((card) => (
        <MiniStatistics
          key={card.name}
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={card.iconBg}
              icon={<Icon as={card.icon} w="32px" h="32px" color={card.iconColor} />}
            />
          }
          name={card.name}
          value={card.value}
        />
      ))}
    </SimpleGrid>
  );
}
